// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_CONTACT_OR_sendmsg = "nebo %(sendmsg)s";
